import * as React from 'react';

import DocumentCreationButton from 'Components/DocumentCreationButton';
import DocumentHeader from 'Components/DocumentHeader';
import DocumentWrapper from 'Components/DocumentWrapper';
import { FormContextProvider, HistoryContextProvider } from 'Containers/FormContextHandler';
import FormEditingHandler from 'Containers/FormEditingHandler';
import SurgicalTreatmentForm from './Form';
import SurgicalTreatmentHistoryRow from './HistoryRowData';
import { filterByDocumentType } from 'Utility/documentHandling';

const SurgicalTreatment = ({ documents }: ISurgicalTreatmentProps): React.JSX.Element => {
  const surgicalTreatmentDocuments = filterByDocumentType(documents, 'epilepsySurgicalTreatment');

  return (
    <FormEditingHandler name="surgicalTreatment" documents={surgicalTreatmentDocuments}>
      {(editing, startEdit, formData, view): React.JSX.Element => (
        <DocumentWrapper>
          <DocumentHeader
            name="surgicalTreatment"
            headerId="surgicalTreatment.title"
            editing={editing}
            editButtons={
              <DocumentCreationButton
                name="surgicalTreatment"
                text={'surgicalTreatment.add'}
                onClick={startEdit({}, 'epilepsySurgicalTreatment')}
                asyncOnClick={undefined}
              />
            }
          />
          <FormContextProvider context={{ formData, editing, view }}>
            {editing || view?.viewing ? <SurgicalTreatmentForm /> : null}
          </FormContextProvider>
          <HistoryContextProvider context={{ startEdit, view, documents: surgicalTreatmentDocuments }}>
            {!editing && !view?.viewing ? <SurgicalTreatmentHistoryRow /> : null}
          </HistoryContextProvider>
        </DocumentWrapper>
      )}
    </FormEditingHandler>
  );
};

interface ISurgicalTreatmentProps {
  documents: Array<IDocumentWithTypeV2<'epilepsySurgicalTreatment'>>;
}

export default SurgicalTreatment;
